export enum LocalStorage {
    sidebarSize = 'sidebarSize',
}
